import React, { useContext, useState, useEffect } from "react";
import { Button, Input } from "antd";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";

const CreditoRemoto = (props) => {

  const styles = `
.Maquinas-page {
  background-color: black;
  color: white;
  margin: 0;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100vw;
  overflow: auto;   
}
.Container_Principal {
  display: flex;
  flex-direction: column; 
  align-items: center;
  width: 100%;
  max-width: 500px; 
  padding: 20px;
  background-color: #333;
  border-radius: 8px;
  position: absolute; 
  top: 50%; 
  left: 50%; 
  transform: translate(-50%, -50%); 
}
.input-group {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}
.Trocar_itemFieldLabel {
  margin-right: 15px;
  min-width: 80px;
  text-align: center;
  color:rgb(246, 250, 4);
}
.Trocar_itemField {
  flex: 1;
}
.button-group {
  display: flex;
  width: 100%;
  gap: 15px;
  margin-top: 20px;
  position: relative;
  z-index: 1;
}

.Trocar_saveBtn,
.Botao-Voltar {
    flex: 1;
    margin: 0 10px;
    font-size: 20px;
    padding: 20px;
    height: 25px;
    width: 100%; 
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #ffffff;
    max-width: 300px; 
}


.Trocar_saveBtn {
  background-color: #4CAF50;
}
.Botao-Voltar {
  background-color: #fc4f44;
}
.button-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
  `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const [data, setData] = useState({
    valor: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {
    let errorsTemp = {};
    if (data.valor === "") {
      errorsTemp.valor = "Este campo é obrigatório";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_SERVIDOR}/credito-remoto`,
        { id, valor: data.valor },
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        setNotiMessage({
          type: "success",
          message: res?.data?.retorno,
        });
      })
      .catch((err) => {
        setIsLoading(false);

        setNotiMessage({
          type: "error",
          message: err.response?.data?.msg
            ? err.response?.data?.msg :
            "Sua sessão expirou, faça login novamente. 06",
        });
      });
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div>
        <div className="Maquinas-page">

          <div className="Container_Principal">
            <div className="Trocar_itemField">
              <label className="Trocar_itemFieldLabel" htmlFor="valor">
                ADICIONAR CRÉDITOS NESTA MÁQUINA:
              </label>
              <Input
                placeholder={""}
                value={data.valor}
                id="valor"
                type="text"
                name="valor"
                autoComplete="valor"
                onChange={(event) => {
                  handleChange("valor", event.target.value);
                }}
                className={`${!!errors.valor ? "Trocar_inputError" : ""}`}
              />
              {errors.valor && (
                <div className="Trocar_itemFieldError">{errors.valor}</div>
              )}
            </div>
            <div className="button-group">
              <Button
                className="Trocar_saveBtn"
                onClick={() => {
                  if (!isLoading) onSave();
                }}
                disabled={isLoading}
              >
                ENVIAR
              </Button>

              <Button
                className="Botao-Voltar"
                onClick={() => {
                  navigate(`/cliente-maquinas/pagamentos/${id}`, {
                    state: location.state,
                  });
                }}
              >
                <span>VOLTAR</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditoRemoto;
